import themeCss from '../../components/sass/theme.module.scss'
import { formatMoney } from 'services/util'

export default function ClosedAuctionAttendeeItemRow( {item, isSelected, toggleCheckbox} ) {
  const isAboveFairMarketValue =
    item.rowType === 'item'
      ? item.CurrentBid > item.Value
      : item.rowType === 'fixedItem'
        ? item.TotalAmount > ((item.Value || 0) * (item.Quantity || 0))
        : false

  return (
    <tr>
      <td>
        <input type='checkbox'
          checked={isSelected}
          disabled={item.Paid}
          onChange={() => toggleCheckbox(item)}
          />
      </td>
      <td>{item.Title}</td>
      <td>{item.Quantity}</td>
      {item.Paid ? <td>$0</td> : <td className={isAboveFairMarketValue ? themeCss['boldGreen']: ''}>${formatMoney(item.AmountDue)}</td>}
      {item.Paid ? <td className={isAboveFairMarketValue ? themeCss['boldGreen'] : ''}>YES</td> : <td>NO</td>}
    </tr>
  )
}
